import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import ContactViewModel from "@/models/ContactViewModel";

export default function (options?: { captainEmail?: string }) {
    const captainEmail = options && options.captainEmail ? options.captainEmail.toLowerCase() : undefined;

    const add = async (contact: ContactViewModel): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.post("/api/contact", contact)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const update = async (contact: ContactViewModel): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.put(`/api/contact/${contact.id}`, contact)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const remove = async (id: number): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.delete(`/api/contact/${id}`)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const get = async (id: number): Promise<ContactViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get(`/api/contact/${id}`)
                .then((result: AxiosResponse<ContactViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const getCaptain = async (deviceId: string): Promise<ContactViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get(`/api/contact/${deviceId}`)
                .then((result: AxiosResponse<ContactViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const nameRules: ((v: any) => any)[] = [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 30) || "Name must be less than 30 characters",
    ];

    const emailRules: ((v: any) => any)[] = [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        (v) =>
            !captainEmail || v.toLowerCase() !== captainEmail ||
            "This email belongs to the captain and cannot be used",
    ];

    return {
        add,
        update,
        remove,
        get,
        getCaptain,
        nameRules,
        emailRules,
    };
}
